<template>
    <div>
        <div
            v-if="scale.type !== '100'"
            style="display:flex; margin-top: -5px; margin-bottom: -5px"
            class="text-center"
        >
            <button
                v-for="item in Array.from(
                    {
                        length: scale.type,
                    },
                    (_, i) => i + 1,
                )"
                :key="item"
                v-b-popover.hover.top="scale['r' + item].label"
                style="flex: 1 1 0px"
                class="btn btn-primary ellipse-text"
                :class="{
                    'btn-raised': amount == scale['r' + item].amount,
                }"
                @click="
                    () => {
                        amount = scale['r' + item].amount;
                    }
                "
            >
                <span v-if="!scale.hideNumbers"> {{ item }} / </span>
                {{ scale["r" + item].label }}
            </button>
            <button
                v-if="ratingRequirement === 'optional'"
                v-b-popover.hover.top="$t(`reviews.update.helpOptional`)"
                class="btn btn-primary"
                style="flex: 1 1 0px"
                :class="{ 'btn-raised': amount === -50 }"
                @click="
                    () => {
                        amount = -50;
                    }
                "
            >
                N/A
            </button>
        </div>
        <div v-else>
            <div class="volumeRow">
                <span
                    v-b-popover.hover.bottom="{ content: scale.r1.label }"
                    style="margin-top: 5px; margin-right: 30px"
                    tabindex="0"
                    @click="amount = 0"
                    @keyup.enter="amount = 0"
                >
                    <span class="explanation mouseover tw-mr-2">
                        {{ scale.r1.label.slice(0, 18) }}
                        <span v-show="scale.r1.label.length > 18">
                            ...
                        </span>
                    </span>
                    <span style="font-size: 21px;">
                        <i class="fal fa-rocket color-warning"></i>
                    </span>
                </span>

                <span
                    class="volumeBar"
                    data-test-class="feedback-create-skill-volume-bar"
                    @mousedown="e => sliderMouseDown(e)"
                    @mouseup="e => sliderMouseUp(e)"
                    @mousemove="e => sliderMouseMove(e)"
                >
                    <span class="volumebkg"></span>
                    <span
                        ref="volume"
                        class="volume"
                        :style="
                            sliderStyle({
                                percentage: amount,
                            })
                        "
                    ></span>
                </span>

                <span
                    v-b-popover.hover.bottom="{ content: scale.r5.label }"
                    style="margin-left: 35px;"
                    tabindex="0"
                    @click="amount = 100"
                    @keyup.enter="amount = 100"
                >
                    <span style="font-size: 21px">
                        <i class="fal fa-rocket color-success"></i>
                    </span>
                    <span class="explanation mouseover tw-ml-2">
                        {{ scale.r5.label.slice(0, 18) }}
                        <span v-show="scale.r5.label.length > 18">
                            ...
                        </span>
                    </span>
                </span>
            </div>

            <div class="text-center explanation" style="margin-bottom: 20px">
                <span
                    v-show="ratingRequirement === 'optional'"
                    class="color-primary"
                    tabindex="0"
                    @click="
                        () => {
                            amount = -50;
                        }
                    "
                    @keyup.enter="
                        () => {
                            amount = -50;
                        }
                    "
                >
                    {{ $t(`reviews.update.labelMarkAsNA`) }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        scale: {
            type: Object,
            required: true,
        },
        amount: {
            type: Number,
            required: true,
        },
        feedbackSignalIndex: {
            type: Number,
            required: true,
        },
        ratingRequirement: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            volumeDrag: false,
        };
    },
    watch: {
        amount: {
            handler() {
                this.$emit("update", {
                    amount: this.amount,
                    feedbackSignalIndex: this.feedbackSignalIndex,
                });
            },
        },
    },
    methods: {
        sliderMouseDown(e) {
            this.volumeDrag = true;
            this.updateVolume(e.offsetX);
        },

        sliderMouseUp(e) {
            this.volumeDrag = false;
            this.updateVolume(e.offsetX);
        },

        sliderMouseMove(e) {
            if (this.volumeDrag) {
                this.updateVolume(e.offsetX);
            }
        },

        sliderStyle({ percentage }) {
            return {
                clip: "rect(0px, " + percentage * 2.2 + "px, 30px, 0px)",
                "border-color":
                    percentage <= 55
                        ? "transparent transparent #ffb54a transparent"
                        : "transparent transparent #5D5DE9 transparent",
            };
        },

        updateVolume(offsetX) {
            var percentage;

            // we need to distinguish between two cases: offsetX > 0 (Safari) and offsetX < 0 (all others)

            if (offsetX < 0) {
                percentage = Math.round(((offsetX + 220) / 220) * 100);
            } else {
                percentage = Math.round((offsetX / 220) * 100);
            }

            if (percentage > 100) {
                percentage = 100;
            } else if (percentage < 0) {
                percentage = 0;
            }

            this.amount = percentage;
        },
    },
};
</script>
